import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'

import reducer from './reducers/index'
import rootSaga from './sagas/root'

export const initialState = {
  activeDropdown: null,
  userData: {
    language: null
  },
  reader: {
    bookmarks: []
  },
  appearence: {
    size: 14,
    color: 'white',
    font: 'inherit',
    flow: '1page'
  }
}

const sagaMiddleware = createSagaMiddleware()

const composeEnhancers = composeWithDevTools({
})

const store = createStore(
  reducer,
  initialState,
  composeEnhancers(
    applyMiddleware(sagaMiddleware)
  )
)

sagaMiddleware.run(rootSaga)

export default store



// WEBPACK FOOTER //
// ./src/store.js